import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { Link } from 'modules/UI';

type ContainerProps = {
  isMobile?: boolean;
};

export const SubLinksContent = styled.div`
  display: flex;
  width: max-content;
  margin-left: ${tokens.space.loose};
  height: min-content;
  align-items: center;

  ${tokens.mediaQueries.s} {
    padding: 0 ${tokens.space.regular};
  }
`;

export const Container = styled.div<ContainerProps>`
  position: ${({ isMobile }): string => (isMobile ? 'fixed' : 'absolute')};
  background-color: ${tokens.colors.white};
  min-width: 287px;
  padding: ${({ isMobile }): string => (isMobile ? '0 0 0 24px' : '30px 38px 0px 38px')};
  font-size: ${tokens.fontSizes.s};
  box-sizing: border-box;
  box-shadow: 0px 2px 6px rgba(62, 62, 62, 0.2);
  z-index: 1;
  left: ${({ isMobile = false }): string | false => isMobile && '0'};
  top: ${({ isMobile = false }): string | false => isMobile && '102px'};
  width: ${({ isMobile = false }): string | false => isMobile && '100vw'};
  border-bottom: 1px solid ${tokens.colors.grayLight};
  display: flex;
  flex-direction: ${({ isMobile }): string => (isMobile ? 'column' : 'row')};
  ${tokens.mediaQueries.s} {
    box-shadow: none;
    &.docs {
      height: calc(100% - 102px);
      overflow: scroll;
      padding-bottom: ${tokens.space.regular};
    }

    > div {
      span {
        margin-top: ${tokens.space.large};
      }
    }
  }
`;

export const ModuleItem = styled.div`
  display: flex;
  justify-content: space-between;

  ${tokens.mediaQueries.s} {
    align-items: center;
  }
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Item = styled.li`
  font-family: ${tokens.font.family.ifood.body};
  margin-bottom: ${tokens.space.small};
  color: ${tokens.colors.black};

  ${tokens.mediaQueries.s} {
    margin-bottom: 0;
    height: 55px;
    display: flex;
    align-items: center;
  }
`;

export const MiniLink = styled(Link)`
  font-size: ${tokens.fontSizes.xs};
  white-space: nowrap;

  ${tokens.mediaQueries.s} {
    font-size: ${tokens.fontSizes.s};
    padding: 0 ${tokens.space.smaller};
  }
`;

export const ModulesContent = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  padding-left: ${({ isMobile }): string => (isMobile ? '0' : tokens.space.loose)};
  position: relative;

  &:before {
    content: ' ';
    position: absolute;
    width: 1px;
    height: 90%;
    background: ${tokens.colors.gray};
    top: 0;
    left: 14px;
    ${({ isMobile }) => isMobile && 'display: none'}
  }
`;

export const ReferenceContainer = styled.div`
  margin-left: ${tokens.space.regular};
  position: relative;

  &:before {
    content: ' ';
    position: absolute;
    width: 1px;
    height: 10px;
    background: ${tokens.colors.gray};
    top: 7px;
    left: -8px;
  }
`;
